import { useCallback, useEffect, useMemo, useState } from 'react'

import { ICheckedValue } from 'core-components/library/list/types'
import {
  MultiSelect,
  recalculateWithChildrenValues,
  updateCheckedValues,
} from 'core-components/library/multiSelect'
import { Static } from 'core-components/types'
import { callProcedure } from 'src/core/classes/helpers/callProcedure'
import { ICountryHierarchy } from 'src/core/classes/models/IReference'
import { Crud } from 'src/core/types/Crud'
import Logger from 'src/core/utils/Logger'

import { CHECKED_ADDITIONAL_FIELDS, HIERARCHY_FIELD } from './locationTree/constants/fields'

export interface ILocationTree {
  value: string[]
  onChange: (value: string[], items: ICountryHierarchy[]) => void
  className?: string
  label?: string
  limit?: number
  checkFn?: ((value: string) => Promise<string>) | null
  margin?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  disabled?: boolean
  mode?: LocationMode // todo: MOVE TO LUT / REMOVE
  root?: string // todo: MOVE TO LUT / REMOVE
  hideHpOrg?: boolean // todo: MOVE TO LUT / REMOVE
}

export enum LocationMode {
  CountryCode = 'CountryCode',
  CountryName = 'CountryName',
}

export const LocationTree = ({
  value,
  onChange,
  className,
  label,
  limit,
  checkFn,
  margin,
  disabled,
}: ILocationTree) => {
  const [countries, setCountries] = useState<ICountryHierarchy[]>([])
  const [checkedValues, setCheckedValues] = useState<ICheckedValue[]>([])

  const locationCrud = useMemo(() => {
    const fetcher = new Static(countries)

    return new Crud({
      fetcher,
      ...CHECKED_ADDITIONAL_FIELDS,
      defaultPaging: {
        page: 0,
        pageSize: 10000,
      },
    })
  }, [countries])

  const getItemsByKey = useCallback(
    (keys: string[]) => {
      return countries.filter((el) => keys.includes(el.Id))
    },
    [countries]
  )

  useEffect(() => {
    callProcedure('spApp_getCountriesHierarchy').then(setCountries).catch(Logger.error)
  }, [])

  useEffect(() => {
    const selectedItems = countries.filter((el) => value?.includes(el.Id))
    updateCheckedValues(selectedItems, countries, {
      fields: CHECKED_ADDITIONAL_FIELDS,
      checkedValues: [],
      setCheckedValues,
    })
  }, [value, countries])

  return (
    <MultiSelect
      disabled={disabled}
      margin={margin}
      limit={limit}
      checkFn={checkFn}
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      useRowCheckbox
      caption={'Title'}
      label={label}
      checkedValues={checkedValues}
      onCheck={(item, value, items) => {
        const newValues = recalculateWithChildrenValues(
          item,
          value,
          items,
          {
            fields: CHECKED_ADDITIONAL_FIELDS,
            checkedValues,
            setCheckedValues,
          },
          HIERARCHY_FIELD
        )
        onChange(newValues, getItemsByKey(newValues))
      }}
      source={locationCrud}
      onChange={(newValues) => {
        onChange(newValues, getItemsByKey(newValues))
      }}
      value={value}
    />
  )
}
